export enum ViewColumnsAddSectionItemBlock {
  Root = 'ViewColumnsAddSectionItem',
}
